<template>
    <div>
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0" v-if="($parent.isMultiStep && $parent.currentStep===1)||(!$parent.isMultiStep)">
      <div class="mt-8 mb-6 sm:mt-20 px-2">
        <div class="text-left">
          <h1
            class="text-3xl tracking-tight font-black text-primary mb-2"
          >
            <span class="block">Your details</span>
          </h1>
          <p class="text-lg text-primary font-extrabold">We need a few details to get you registered.</p>
        </div>
      </div>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }">
        <form
            class="space-y-4 text-black"
            @submit.prevent="handleSubmit(onSubmit)"
            data-testid="registration-form"
        >
        <div v-if="($parent.isMultiStep && $parent.currentStep==1)||(!$parent.isMultiStep)">
            <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mb-4" >
                <div class="w-full px-2">
                    <ValidationProvider
                        rules="required|min:3"
                        v-slot="{ errors, valid }"
                    >
                        <label class="block mb-2 text-sm font-medium" for="formGridCode_name"
                            >Full name</label
                        >
                        <input
                            class="w-full h-10 px-3 text-base placeholder-gray-600 border border-gray rounded-lg focus:shadow-outline"
                            type="text"
                            id="formGridCode_name"
                            name="name"
                            v-model="form.name"
                            placeholder="Your Name to be shown at graduation"
                            v-bind:class="{
                                'border-red-700 text-red-900': errors.length > 0,
                                'border-green-700': valid,
                            }"
                        />
                        <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mb-4">
                <div class="w-full px-2">
                    <ValidationProvider
                        name="Email Address"
                        rules="required|email|personal_email"
                        v-slot="{ valid, errors }"
                        vid="email"
                    >
                        <label class="block mb-2 text-sm font-medium" for="formGridCode_email"
                            >Email Address</label
                        >
                        <input
                            ref="email"
                            class="w-full h-10 px-3 text-base placeholder-gray-600 border border-gray rounded-lg focus:shadow-outline"
                            type="email"
                            id="formGridCode_email"
                            name="email"
                            v-model="form.email"
                            placeholder="john.doe@example.com"
                            v-bind:class="{
                                'border-red-700 text-red-900': errors.length > 0,
                                'border-green-700': valid,
                            }"
                        />
                        <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mb-4">
                <div class="w-full px-2">
                    <ValidationProvider
                        name="Confirmation Email Address"
                        rules="required|confirmed:email"
                        v-slot="{ valid, errors }"
                    >
                        <label class="block mb-2 text-sm font-medium" for="formGridCode_email_conf"
                            >Confirm Email Address</label
                        >
                        <input
                            class="w-full h-10 px-3 text-base placeholder-gray-600 border border-gray rounded-lg focus:shadow-outline"
                            type="email"
                            id="formGridCode_email_conf"
                            name="confirmed_email"
                            v-model="form.confirmEmail"
                            placeholder="john.doe@example.com"
                            v-bind:class="{
                                'border-red-700 text-red-900': errors.length > 0,
                                'border-green-700': valid,
                            }"
                        />
                        <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            </div>

            <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0" v-if="($parent.isMultiStep && $parent.currentStep === 2)||(!$parent.isMultiStep)">
    <div class="w-full px-2">
        <div class="mt-8 mb-6 sm:mt-20">
        <h1 v-if="($parent.isMultiStep && $parent.currentStep === 2)"
            class="text-3xl tracking-tight font-black text-primary mb-2"
          >
            <span class="block">Graduation details</span>
          </h1>
          <p class="text-lg text-primary font-extrabold">Enter the details of your graduation.</p>
          </div>
        <ValidationProvider
            v-if="!hideEvent"
            name="Graduation Date"
            rules="required"
            v-slot="{ valid, errors }"
        >
            <label class="block mb-2 text-sm font-medium" for="formGridCode_event">
                Your Graduation Date
            </label>
            <select
                v-model="form.event"
                @change="onGraduationDateChange"
                class="w-full h-10 px-3 text-base placeholder-gray-600 border border-gray rounded-lg focus:shadow-outline"
                id="formGridCode_event"
                name="event"
                v-bind:class="{
                    'border-red-700 text-red-900': errors.length > 0,
                    'border-green-700': valid,
                }"
            >
                <option selected disabled :value="null">
                    Select your graduation date
                </option>
                <option
                    v-for="ceremony in events"
                    :key="ceremony.id"
                    :value="ceremony.id"
                >
                    {{ formatCeremonyOption(ceremony) }}
                </option>
            </select>
            <span class="text-red-500 text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</div>

            <div
                v-for="(field) in additionalFields"
                :key="field.name"
                class="flex flex-wrap -mx-2 space-y-4 md:space-y-0"
            >
                <div class="w-full px-2">
                    <ValidationProvider :rules="field.rules" v-slot="{ valid, errors }">
                        <label
                            v-if="field.titleFormat == 'markdown'"
                            class="block mb-1 markdownHtmlCustom"
                            style=""
                            :for="field.name"
                            v-html="markdownHtml(field.title)"
                            ></label
                        >
                        <label
                            class="block mb-1"
                            style="white-space: pre-wrap"
                            :for="field.name"
                            v-else
                        >{{ field.title }}</label>
                        <div v-if="field.type === 'presentationOnly'"></div>
                        <div v-else-if="field.type === 'markdown'" class="markdownHtmlCustom" v-html="markdownHtml(field.content)"></div>
                        <div v-else-if="field.type === 'radio'">
                            <div v-for="(choice, c_index) in field.choices" :key="c_index">
                                <label :for="choice.value">{{ choice.text }} </label>
                                <input
                                    type="radio"
                                    v-model="getField(field).value"
                                    :id="choice.value"
                                    :name="field.name"
                                    :value="choice.value"
                                    :disabled="!field.enabled"
                                />
                            </div>
                        </div>
                        <div v-else-if="field.type === 'select'">
                            <select
                                :id="field.name"
                                :name="field.name"
                                :disabled="!field.enabled"
                                class="w-full h-10 px-3 text-base placeholder-gray-600 border border-gray rounded-lg focus:shadow-outline"
                                v-model="getField(field).value"
                                :ref="field.name"
                                v-bind:class="{
                                    'border-red-700 text-red-900': errors.length > 0,
                                    'border-green-700': valid,
                                }"
                            >
                                <option selected disabled :value="null">
                                    {{ field.default }}
                                </option>

                                <option
                                    v-for="(choice, c_index) in field.choices"
                                    :key="c_index"
                                    :value="choice.value"
                                    :data-unique="'unique' in choice ? choice.unique : choice.value"
                                >
                                    {{ choice.text }}
                                </option>
                            </select>
                        </div>
                        <div v-else-if="field.type === 'multi-select'">
                            <div class="flex items-center gap-1.5 mb-2" v-for="(choice, c_index) in field.choices" :key="c_index">
                                <input
                                    type="checkbox"
                                    v-model="getField(field).value"
                                    :id="choice.value"
                                    :name="field.name"
                                    :value="choice.value"
                                    :disabled="!field.enabled"
                                />
                                <label :for="choice.value" class="text-sm font-medium text-secondary">{{ choice.text }} </label>
                            </div>
                        </div>
                        <input
                            v-else
                            class="w-full h-10 px-3 text-base placeholder-gray-600 border border-gray rounded-lg focus:shadow-outline"
                            :type="field.type"
                            :id="field.name"
                            :name="field.name"
                            :disabled="!field.enabled"
                            :placeholder="field.placeholder"
                            v-model="getField(field).value"
                            v-bind:class="{
                                'border-red-700 text-red-900': errors.length > 0,
                                'border-green-700': valid,
                            }"
                        />
                        <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <button
                type="submit"
                data-testid="registration-submit"
                :disabled="submitDisabled"
                class="inline-flex w-full justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-extrabold rounded-md text-white bg-blue-500 hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-500"
            >
                {{ submitButtonText }}
            </button>
        </form>
    </ValidationObserver>
</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import marked from 'marked';

export default {
    name: 'FormSection',
    components: {
        ValidationObserver,
        ValidationProvider
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        events: {
            type: Array,
            required: true
        },
        additionalFields: {
            type: Array,
            required: true
        },
        submitButtonText: {
            type: String,
            default: 'Continue'
        },
        submitDisabled: {
            type: Boolean,
            default: false
        },
        hideEvent: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        markdownHtml(value) {
            if (!value) return '';
            return marked.parse(value);
        },
        getField(field) {
            const foundField = this.form.additionalFields.find((f) => f.name === field.name);
            if (!foundField) {
                return {
                    ...field,
                    value: field.type === 'multi-select' ? [] : undefined
                };
            }
            return foundField;
        },
        onGraduationDateChange() {
            this.$emit('graduation-date-change', this.form.event);
        },
        onSubmit() {
            if (this.submitDisabled) return;
            this.$emit('submit', this.form);
        },
        formatCeremonyOption(ceremony) {
            if (!ceremony) {
                return '';
            }
            const formattedDate = this.formatDate(ceremony.datetime);
            return ceremony.label ? `${formattedDate} - ${ceremony.label}` : formattedDate;
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleDateString('en-GB', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });
        }
    }
};
</script>

<style scoped>
.markdownHtmlCustom a {
    text-decoration: underline !important;
}
</style> 
